<script>
  import { onMount, tick } from 'svelte';
  import Zoom from './Zoom.svelte'  
  import { getPgCount, getArticles, setArticles, setState, setUrl } from './logic'
  import { logged, page, pagenum } from './stores'
	import Paging from './Paging.svelte';
  
  // export let issueId
  export let issue
  const index = 'lines'
  let pgCount = 2
  // let left = 1 
  // export {left as pg}
  let data
  let error 
  let modified = false
  let ratified = '', excluded = ''
  
  onMount(async () => {
    await get()
  })
  
  async function get() {
    ({ error, data } = await getArticles(issue.id, index))
    console.log('get', data)
    
    if (data) {
      pgCount = getPgCount(data)
      await tick()
      modified = false
    }
  }

  async function setArticle() {
    error = await setArticles(data, issue.id, index)
    console.log('res1', error)
    if (!error) { 
      modified = false
      error = await setState(issue.id, 'proheadings', $logged)
      console.log('res1b', error)
    }
  }

  async function ratify() {
    error = await setArticle()
    console.log('res2', error)
    if (!error) error = await setState(issue.id, 'headings', $logged)
    console.log('res2b', error)
    if (!error) {
      ratified = 'shváleno'
      setTimeout(() => {$page = 'list'}, 1000)
    }
  }

  async function exclude() {
    error = await setState(issue.id, 'exclude', $logged)
    console.log('res3', error)
    if (!error) {
      excluded = 'vyřazeno'
      setTimeout(() => {$page = 'list'}, 1000)
    }
  }
  
  //$: if (left < 1) left = 1
  // $: if (left > pgCount) left = pgCount
  $: if (data) modified = true
</script>
<!-- {JSON.stringify(data)} -->
<p class="mb-2">Uloženo: 
  <span class="ready" class:modified>{modified? 'ne' : 'ano'}</span>    
  <input type="button" class="btn btn-green py-0.5" value="uložit" disabled={!modified} on:click|preventDefault={setArticle} />
  {#if $pagenum === pgCount}
    <input type="button" class="btn btn-green py-0.5" value="schválit" on:click|preventDefault={ratify} />
    {#if ratified}<span class="success">{ratified}</span>{/if}
  {/if}
  {#if error}<span class="error">{error}</span>{/if}
  <!-- <input class="right" type="button" value="reset" disabled={!modified} on:click|preventDefault={get} /> -->
</p>
<!-- {JSON.stringify(data)} -->
<!--{modified} {data?.length} {JSON.stringify(state)} {pgCount} -->

{#if data}
  <Zoom src="/issue/{issue.id}/{$pagenum}" let:params>
    <!-- {JSON.stringify(params)} -->
    <!-- <Article bind:articles={data} page={$pagenum} {...params} /> -->
    <div>
      {#if !params.moving}
        {#each data as article}
          <!-- {JSON.stringify(article)} -->
          {#each article.groups as group, order}
            {#if +group.page === $pagenum}
              <div class="group"
                  style:background-color={group.type === 'fulltext' ? 'rgba(149, 165, 166, 0.5)' : 'rgba(243, 61, 186, 0.4)'}
                  style:top="{group.vpos*params.scale+params.offsety}px"
                  style:left="{group.hpos*params.scale+params.offsetx}px"
                  style:width="{group.width*params.scale}px"
                  style:height="{group.height*params.scale}px"
              >
                <span on:mousedown|stopPropagation={() => group.type === 'fulltext' ? group.type = 'heading': group.type = 'fulltext'}>
                  {order+1}
                </span>
                <!-- {#if group.type === 'heading' || group.type === 'sub'}
                  <span on:mousedown|stopPropagation={() => {console.log('span'); group.type === 'heading' ? group.type = 'sub': group.type = 'heading'}}>
                    sub
                  </span>
                {/if} -->
              </div>
            {/if}
          {/each}
        {/each}
      {/if}  
    </div>
  </Zoom>
 
  <div class="flex justify-between mt-1">
    <span class="w-10">&nbsp;</span>
    <Paging id={issue.id} {pgCount}/>
    <div class="">
      {#if excluded}<span class="success">{excluded}</span>{/if}
      <button type="button" class="btn btn-green" on:click={exclude}>vyřadit</button>
    </div>
  </div>
{/if}


<style>
  .group:nth-child(2n) span {
    float: left;
  }
</style>